//============================================================================
// Name        : ls_sync_base.ts
// Purpose     : Base class to provide dialog helpers, etc.
// Created     : 2020-12-27
// Author      : Senitron Team
// Copyright   : Copyright 2020 Senitron Corporation. All rights reserved.
//============================================================================

import axios from "axios";

declare var App: any;
declare var $: any;
declare const storeLocation: string;

export interface IChannelData {
    message: string;
    inProgress: boolean;
    success: boolean;
    tag: string;
}

export class LsSyncBase {
    dialogId: string;
    subscription: any;
    protected pushingToLs = false;
    syncDialogContinueButton                  = $("#syncDialog .continueBtn");
    syncDialogDoSyncButton                    = $("#syncDialog .doSyncBtn");
    downloadDialogContinueButton              = $("#downloadDialog .continueBtn");
    syncCategoriesDialogContinueButton        = $("#syncCategoriesDialog .continueBtn");
    syncCategoriesDialogDoSyncButton          = $("#syncCategoriesDialog .doSyncBtn");
    syncDialogReDownloadCheckBox              = $("#syncDialog #re_download_lightspeed_inventory");
    // syncDialogCheckLsAccessButton             = $("#syncDialog .checkLsAccessBtn");
    // downloadDialogCheckLsAccessButton         = $("#downloadDialog .checkLsAccessBtn");
    // syncCategoriesDialogCheckLsAccessButton   = $("#syncCategoriesDialog .checkLsAccessBtn");

    constructor(dialogId: string) {
        this.dialogId = dialogId;
        $(`#${this.dialogId} .close`).on("click", () => { this.hide(); });
    }

    connectLScable(dialogId: string, receivedHandler: (data: any) => void): void {
        App.lsSyncChannel = App.cable.subscriptions.create(
            { // Connection configuration
                channel: "LightspeedSyncChannel",
                roomId: `ls_sync_${storeLocation}`
            },
            { // Pass in connection callbacks
                connected() {
                    console.log("connected to sync channel");
                    // $(`#${dialogId} .checkLsAccessBtn`).removeProp("disabled");
                    $(`#${dialogId} .continueBtn`).removeProp("disabled");
                },
                disconnected() {
                    console.log("disconnected to sync channel");
                    App.cable.subscriptions.remove(this);
                    // $(`#${dialogId} .checkLsAccessBtn`).prop("disabled", true);
                    $(`#${dialogId} .continueBtn`).prop("disabled", true);
                },
                received: (data: any) => receivedHandler(data)
            }
        );
        this.subscription = App.lsSyncChannel;
    }

    disconnect(): void {
        //console.log("App.cable.subscriptions details: ", App.cable.subscriptions);
        App.cable.disconnect();
    }

    hide(): void {
        this.disconnect();
        $(`#${this.dialogId}`).modal("hide");
    }

    refreshPage(): void {
        window.location.reload();
    }

    UpdateCurrentStatus(statusMsg: string, inProgress: boolean, success: boolean): void {
      const $dialog = $(`#${this.dialogId}`);
      const $currentStatus = $dialog.find(".currentStatus");

      // Unhide without wiping intentional inline display (e.g. downloadDialog's flow-root).
      // Only clear an inline `display: none` left by jQuery .hide() / Bootstrap hide.
      $currentStatus.removeClass("hide");
      if ($currentStatus.get(0)?.style.display === "none") {
        $currentStatus.css("display", "");
      }

      if (statusMsg.startsWith('Before syncing')) {
        $dialog.find(".sync-description").addClass("hide");
        $dialog.find("#redownload-checkbox, .currentStatus .success-img, .currentStatus .fail-img").hide();
        $("#sync-close-footer").show();
        $currentStatus.find(".statusDesc").html(`<div class='red'>${statusMsg}</div>`);
        $currentStatus.find(".progress-spin").fadeOut();

        return;
      }

        $currentStatus.find(".statusDesc").html(statusMsg);
        if (inProgress) {
            $currentStatus.find(".progress-spin").removeClass("hide").show();
            $currentStatus.find(".success-img, .fail-img").hide();
        }
        else {
            $currentStatus.find(".progress-spin").fadeOut();
            if (success) {
                $currentStatus.find(".success-img").removeClass("hide").show();
                $currentStatus.find(".fail-img").hide();
            }
            else {
                $currentStatus.find(".success-img").hide();
                $currentStatus.find(".fail-img").removeClass("hide").show();
            }
        }

        if (!inProgress && success && !this.pushingToLs) {
            // Preview complete: enable Proceed controls. Mid-sync uses pushingToLs instead.
            $dialog.find(".previewSyncBtn").removeAttr("disabled");
            $dialog.find(".previewSyncBtn").attr("href", $dialog.find(".previewSyncBtn").data("href"));
            $dialog.find(".doSyncBtn").removeProp("disabled");
        }
    }

    // Mid-sync: keep status in the middle box; hide Preview / Proceed / Close.
    // Do not show Continue & Refresh yet — that belongs on success only.
    // Sync-only — do not call from download (see showRefreshBtn).
    beginProceedSyncUi(): void {
        const $dialog = $(`#${this.dialogId}`);
        $dialog.find(".modal-footer > button[data-dismiss='modal']").hide();
        $dialog.find(".previewSyncBtn, .doSyncBtn").hide();
        $dialog.find(".sync-actions").removeClass("hide").show();
        $dialog.find(".finalStatus").addClass("hide").hide();
        const $currentStatus = $dialog.find(".currentStatus");
        $currentStatus.removeClass("hide");
        if ($currentStatus.get(0)?.style.display === "none") {
            $currentStatus.css("display", "");
        }
        $dialog.find(".refreshBtn").addClass("hidden").hide();
    }

    // Terminal failure during proceed-with-sync: restore Close, keep refresh hidden.
    showProceedSyncFailedUi(): void {
        const $dialog = $(`#${this.dialogId}`);
        $dialog.find(".modal-footer > button[data-dismiss='modal']").show();
        $dialog.find(".refreshBtn").addClass("hidden").hide();
    }

    // static UpdateCheckLSAccessStatus(dialogId: string, statusMsg: string, inProgress: boolean, success: boolean): void {
    //     $(`#${dialogId} .checkLsAccessStatus .statusDesc`).html(statusMsg);
    //     if (inProgress) {
    //         $(`#${dialogId} .checkLsAccessStatus .progress-spin`).fadeIn();
    //     }
    //     else {
    //         $(`#${dialogId} .checkLsAccessStatus .progress-spin`).fadeOut();
    //     }
    //
    //     if (success) {
    //         $(`#${dialogId} .checkLsAccessStatus .success-img`).show();
    //         $(`#${dialogId} .checkLsAccessStatus .fail-img`).hide();
    //     }
    //     else {
    //         $(`#${dialogId} .checkLsAccessStatus .success-img`).hide();
    //         $(`#${dialogId} .checkLsAccessStatus .fail-img`).show();
    //     }
    //
    //     if (success && inProgress) {
    //         $(`#${dialogId} .checkLsAccessStatus .progress-spin`).fadeOut();
    //         $(`#${dialogId} .checkLsAccessStatus`).show();
    //     }
    // }

    // Shared by sync + download. On sync success this is the "done" footer (Continue & Refresh).
    showRefreshBtn(): void  {
        const $refreshBtn = $(`#${this.dialogId} .refreshBtn`);
        $refreshBtn.off("click").on("click", () => location.reload());
        $refreshBtn.siblings().remove();
        $refreshBtn.removeClass("hidden").show();
        $(`#${this.dialogId} .modal-footer > button[data-dismiss='modal']`).hide();
    }
}
